var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Box, Flex } from "theme-ui";
import { TechnicalParagraph, ButtonVariants, TextVariants, SmallArrowUp, Label2, SmallArrowDown, Colors } from "../../index";
export const CollapsibleNew = (_a) => {
    var { label, children, as = "h3", onVisibilityChange = () => { } } = _a, props = __rest(_a, ["label", "children", "as", "onVisibilityChange"]);
    const [show, setShow] = useState(props.initShow || false);
    const handleClick = (e) => {
        setShow(!show);
    };
    useEffect(() => {
        onVisibilityChange(show);
    }, [show]);
    return (_jsxs(Box, { sx: { color: "text" }, as: "section", children: [_jsxs("button", { onClick: handleClick, "aria-expanded": show, sx: {
                    variant: `buttons.${ButtonVariants.accessible}`,
                    display: "flex",
                    width: " 100%",
                    textAlign: "left",
                    py: 12
                }, children: [_jsx(Label2, { as: as, sx: {
                            flex: 1,
                            color: `${Colors.black}.1`,
                            variant: `text.${TextVariants.label2Bold}`
                        }, children: label }), _jsx(Box, { sx: { pl: 24, alignSelf: "center", justifySelf: "flex-end" }, children: show ? _jsx(SmallArrowUp, {}) : _jsx(SmallArrowDown, {}) })] }), _jsx(Flex, { sx: {
                    mt: 4,
                    display: show ? "block" : "none"
                }, children: _jsx(Box, { hidden: show === false ? true : false, children: React.Children.count(children) > 0 ? (children) : (_jsx(TechnicalParagraph, { children: "Looks like we are missing content." })) }) })] }));
};
//# sourceMappingURL=CollapsibleNew.js.map